import './DevPanel_AmplienceUsagePagination.scss';

import React from 'react';

import { Box, Pagination } from '@mui/material';
import PropTypes from 'prop-types';

const DevPanel_AmplienceUsagePagination = ( { count, page, onChange } ) => {
  if( count <= 1 ){
    return null;
  }

  return (
    <Box className='DevPanel_AmplienceUsagePagination'>
      <Pagination
        count={ count }
        page={ page }
        onChange={ onChange }
        size='small'
        color='primary'
        variant='outlined'
        shape='rounded'
      />
    </Box>
  );
};

DevPanel_AmplienceUsagePagination.propTypes = {
  count: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
};

export default DevPanel_AmplienceUsagePagination;
